module.exports = __webpack_public_path__ + "fonts/baronsans-hairlineitalic-webfont.c225aab9.woff2";